import { fetchConferenceHub } from '@/api/business/processhub'
import { useQuery } from '@tanstack/react-query'

export const ConferenceHubKeys = {
    all: ['conferencehub'] as const, 
    details: () => [...ConferenceHubKeys.all, 'detail'] as const,
    detail: ({
        initialDate,
        finalDate,
    }: {
        initialDate: number
        finalDate: number
    }) => [...ConferenceHubKeys.details(),  { initialDate, finalDate }] as const,
}

export const useConferenceHubQuery = (props : {initialDate: number, finalDate: number}) => {
    return useQuery({
        queryFn: () => fetchConferenceHub({
            finalDate: props.finalDate,
            initialDate: props.initialDate
        }),
        queryKey: ConferenceHubKeys.detail({
            finalDate: props.finalDate,
            initialDate: props.initialDate,
        }),
        refetchInterval: 240000
    })
}
